<template>
  <div class="cenList">
	  <div class="cenListForTile" >
	  	{{list.data.menuTitle}}
	  </div>
	  <div class="cenListForCen">
	  	<div class="cenListForCenFor" v-for="(item,index) in list.data.content" :key="index" @click="goUrl(item)">
	  		<div class="cenListForCenForImg">
	  			<img :src="item.cover">
	  		</div>
	  		<div class="cenListForCenForName">
	  			{{item.title}}
	  		</div>
	  	</div>
	  </div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		list:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {
		// list:[
		// 	{
		// 		img:require("@/assets/product/page6/axb.png"),
		// 		name:'FHD'
		// 	},
		// 	{
		// 		img:require("@/assets/product/page6/axb.png"),
		// 		name:'FHD'
		// 	},
		// 	{
		// 		img:require("@/assets/product/page6/axb.png"),
		// 		name:'澳小宝'
		// 	},
		// ]
      }
    },
    mounted() {

    },
    methods: {
		goDetail(){
			this.$router.push({
				path:'/productDetail',
				name:'productDetail',
				query:{
					id:1
				}
			})
		},
		goUrl(e){
			let url=e.jump_url;
			if(url&&url.indexOf('http')!=-1){
				window.open(url,'_blank')
			}else{
				this.$router.push({
					path:url||'/null',
				})
			}
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.cenList{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.cenListForTile{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 73px;
	}
	.cenListForCen{
		display: flex;
		flex-wrap: wrap;
		.cenListForCenFor:hover{
			.cenListForCenForImg{
				img{
					transform: scale(1.1);
				}
			}
		}
		.cenListForCenFor:nth-of-type(3n-1){
			margin: 0 2%;
		}
		.cenListForCenFor{
			cursor: pointer;
			width: 32%;
			margin-bottom: 30px;
			.cenListForCenForImg{
				overflow: hidden;
				width: 100%;
				height: 260px;
				img{
					width: 100%;
					object-fit: contain;
					transition: all 0.3s ease-in-out;
				}
			}
			.cenListForCenForName{
				font-size: 22px;
				
				font-weight: 400;
				color: #000000;
				margin:32px 0px;
				text-align: center;
				overflow : hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}
	@media screen and (max-width:1200px) {
		.cenList{
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.cenListForTile{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.cenListForCenFor:nth-of-type(3n-1){
				margin: 0 !important;
			}
			.cenListForCenFor:nth-of-type(2n-1){
				margin-right:2% !important;
			}
			.cenListForCenFor{
				width: 49% !important;
				margin-bottom: 20px !important;
				.cenListForCenForImg{
					height: auto !important;
				}
				.cenListForCenForName{
					font-size: 14px !important;
					margin: 10px 0 0 !important;
				}
			}
		}
	}
</style>
